import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	users: {
		id: 'issue-navigator-custom-filters.common.details-popup.users-grant.users',
		defaultMessage: 'Users',
		description: 'Text for users label  .',
	},
});
